import { ModalBody, ModalPanel } from "../../components/Modal"
import { useLocation, useNavigate } from "react-router-dom"
import { useForm } from "react-hook-form"
import { useChatContext } from "../../core/context/chatContext"
import { useProjectsByUser } from "../../core/utils/hooks/useUsers"
import NewChatContainer from "../NewChatContainer"
import "./styles.scss"
import { NewAssistanceModalConfirm } from "../../components/NewAssistanceModalConfirm"

export const StartConversationModal = ({
  modalOpen,
  setModalOpen,
  chatId
}) => {
  return (
    <>
      <ModalPanel width={500} modalIsOpen={modalOpen} shouldCloseOnOverlayClick={true}>
        <ModalBody className="chat-modal-outside-container">
          <NewChatContainer handleCloseModal={setModalOpen} showOnlyChat={true} defaultChat={chatId} />
        </ModalBody>
      </ModalPanel>
    </>
  )
}

const ActionsAssistanceContainer = ({ user, originPath = "chat" }) => {
  const { projectsByUser } = useProjectsByUser(user?.id)
  const {
    openNewAssistance,
    setOpenNewAssistance,
    handleOpenAssistance,
    handleOpenChatScreen,
    chatId,
    chatOpenScreen
  } = useChatContext()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const origin = `from${[originPath]}`

  const { register, getValues, watch, setValue } = useForm({
    mode: "onChange",
  })


  const handleNewAssitanceConfirm = () => {
    setOpenNewAssistance(false)
    navigate(
      `/farmer/profile/${user?.id}?context=false&category=new&origin=${origin}Page`,
      {
        state: {
          [origin]: { ...user, name: user?.name || user?.userNames[0]?.name, projectsByUser, assistanceTitle: getValues()?.assistanceTitle },
        },
      },
    )
    setValue("assistanceTitle", "")
  }

  return (
    <>
      {openNewAssistance && (
        <NewAssistanceModalConfirm
          {...{
            openNewAssistance,
            handleOpenAssistance,
            handleNewAssitanceConfirm,
            register,
            watch,
          }}
        />
      )}

      {chatOpenScreen &&
        <StartConversationModal
          setModalOpen={handleOpenChatScreen}
          modalOpen={chatOpenScreen}
          chatId={chatId}
        />}
    </>
  )
}

export default ActionsAssistanceContainer